import { PublicClientApplication } from "@azure/msal-browser";

const isLocalhost = window.location.hostname === 'localhost';

export const msalConfig = {
    auth: {
        clientId: "a402b8df-7b4c-437b-9601-0648f1598f47",
        authority: "https://login.microsoftonline.com/organizations",
        redirectUri: isLocalhost ? "http://localhost:3000" : "https://desbloqueos.educacioncba.edu.ar",
        navigateToLoginRequestUrl: true, 
    },
    cache: {
        // Usamos sessionStorage en producción y localStorage en local, 
        // pero obligatoriamente storeAuthStateInCookie: true para que el redirect no falle.
        cacheLocation: isLocalhost ? "localStorage" : "sessionStorage",
        storeAuthStateInCookie: true, 
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
   scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};